import React from 'react'
import common from '../../methods/common'

const AttendenceCalender = ({ attendence }) => {

    return (
        <div className='main-container '>
            <h4>Your Attendence Report</h4>
            <div className='scroll-container'>
                {Object.keys(attendence).map(date => {
                    const isSunday = common.isSunday(date)
                    return <div className='attendence-tile'>
                        <span className='attendence-date'>{date}</span>
                        <span className={`attendence-status-${attendence[date].status || (isSunday ? "Sunday" : "") || "NA"}`}>{attendence[date].status || (isSunday ? "Sunday" : "NA")}</span>
                    </div>
                })}
            </div>
        </div>
    )
}

export default AttendenceCalender
